module.exports = __webpack_public_path__ + "img/empty-tkb.b89109d1.svg";